import { Fragment } from 'react';
interface Props {
  title: string;
  link: string;
  classes?: string;
}
export const ViewAll = ({ title, link, classes }: Props) => {
  return (
    <Fragment>
      <a
        href={link}
        className={`lil-btn-link lil-items-center btn-text ${classes}`}
      >
        {title}
        <span className="lil-font-medium">&nbsp; →</span>
      </a>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./components/common/viewAll.tsx